import { InvestmentType } from '@inversor-hub/types';

export const investmentTypeLabels: Record<InvestmentType, string> = {
  TRADITIONAL_RENT: 'Alquiler tradicional',
  ROOM_RENT: 'Alquiler por habitaciones',
  ROOM_SALE: 'Venta de habitación',
  FLIPPING: 'Flipping',
  VACATIONAL: 'Vacacional',
  CHANGE_OF_USE: 'Cambio de uso',
};

// TODO: Remove this and handle all types once we support them
export const handledInvestmentTypes: InvestmentType[] = [
  'TRADITIONAL_RENT',
  'ROOM_RENT',
  'ROOM_SALE',
];
